var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRedoArrowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    viewBox: "0 0 14 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.73425 2.292C11.116 2.65875 13.75 5.5215 13.75 9C13.75 11.0235 12.8545 12.834 11.4437 14.0722L10.219 13.1385C11.4527 12.1762 12.25 10.6815 12.25 9C12.25 6.3555 10.282 4.167 7.73425 3.80775L7.73425 6L3.79675 3L7.73425 -3.27147e-07L7.73425 2.292ZM6.25 14.19C3.70975 13.8247 1.75 11.64 1.75 9C1.75 7.32225 2.54425 5.829 3.7735 4.8675L2.5495 3.9345C1.1425 5.172 0.25 6.98025 0.25 9C0.25 12.474 2.87575 15.3322 6.25 15.7057L6.25 18L10.1875 15L6.25 12L6.25 14.19Z",
    fill: "#F7F7F7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedoArrowIcon);
export default __webpack_public_path__ + "static/media/redo-arrow-icon.291475404a8786d9b4ce93701857b81e.svg";
export { ForwardRef as ReactComponent };